
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react'
const CustomModal = ({ showModalButtonText, modalHeader, modalBody, isOpen, onOpen, onClose, isbuttonVisible = true, size = "xl" }) => {



  return (
    <>
      {isbuttonVisible && (
        <Button bg="#2563eb"  size={"sm"} fontWeight="500" fontFamily="'Open Sans', sans-serif"
          color="#fff" _hover={{ bg: '#2563ebe6' }} onClick={onOpen}>
          {showModalButtonText}
        </Button>
      )}

      <Modal isOpen={isOpen} size={size} onClose={onClose} >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{modalHeader}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            {modalBody}

          </ModalBody>


        </ModalContent>
      </Modal>
    </>
  );
};

export default CustomModal;